<template>
  <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path :fill="color" d="M46.6,78.24v-4.5c0-.69-.48-1.27-1.15-1.45-2.61-.71-4.81-1.87-6.58-3.49-1.74-1.59-3.09-3.8-4.05-6.62-.27-.79.11-1.66.89-1.96l3.62-1.42c.77-.3,1.65.07,1.97.84.81,1.97,1.85,3.5,3.11,4.6,1.55,1.35,3.66,2.02,6.34,2.02,2.22,0,4.08-.51,5.59-1.54,1.51-1.03,2.26-2.55,2.26-4.58,0-1.82-.69-3.33-2.08-4.55-1.39-1.22-3.8-2.34-7.24-3.37-4.98-1.49-8.41-3.36-10.31-5.59-1.89-2.23-2.84-4.76-2.84-7.57,0-3.4,1.07-6.08,3.21-8.05,1.83-1.69,3.87-2.86,6.11-3.53.66-.2,1.14-.78,1.14-1.47v-4.25c0-.85.69-1.54,1.54-1.54h3.85c.85,0,1.54.69,1.54,1.54v4.16c0,.69.46,1.31,1.14,1.48,1.87.45,3.62,1.35,5.26,2.7,1.55,1.28,2.78,2.8,3.68,4.56.4.78.06,1.75-.75,2.11l-3.62,1.61c-.7.31-1.53.06-1.93-.61-.62-1.03-1.37-1.92-2.25-2.67-1.21-1.02-2.84-1.53-4.9-1.53s-3.87.52-5.16,1.57c-1.28,1.05-1.93,2.24-1.93,3.58,0,1.66.58,2.98,1.74,3.97,1.16.99,4.08,2.23,8.76,3.73,3.97,1.21,6.98,2.96,9.04,5.26,2.06,2.3,3.04,5.08,2.93,8.35-.11,3.9-1.28,6.87-3.52,8.92-1.96,1.8-4.37,3-7.24,3.63-.72.16-1.26.77-1.26,1.51v4.14c0,.85-.69,1.54-1.54,1.54h-3.85c-.85,0-1.54-.69-1.54-1.54Z"/>
  </svg>
</template>

<script>
export default {
  name: 'SalesIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
